//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { useFeature } from "flagged";
import React from "react";
import { Routes } from "../../../routes";
import { RenderWithRedirection } from "../../../util/RenderGuard";
import { useDashboardContext } from "../../DashboardContextProvider";
import { useCheckPermissionByUrl } from "../../sidebar/useCheckPermissionByUrl";
import { OrganizationUsageView } from "./OrganizationUsageView";

export const OrganizationUsagePermissionWrap = () => {
  const { selectedOrganization } = useDashboardContext();
  const { checkOrgPermission } = useCheckPermissionByUrl();
  const isBillingV2Enabled = useFeature("billingV2Enabled");
  // GetCreditUsage requires usage.usageitem.list on the organization - the
  // feature flag alone is not enough, since a custom role can grant a viewer
  // deployment access without granting them this permission. Gating on both,
  // here as well as on the sidebar link and the deployment #usage tab, keeps
  // the link and the destination in agreement instead of a viewer following
  // a visible link straight into a page that only ever 403s.
  const hasUsageViewPermission = checkOrgPermission("usage.usageitem.list");
  return (
    <RenderWithRedirection
      renderIf={!!isBillingV2Enabled && hasUsageViewPermission}
      redirectWhenCannotRender={Routes.dashboard_organization_overviewWithId(selectedOrganization?.id || "")}
    >
      <OrganizationUsageView />
    </RenderWithRedirection>
  );
};
